import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showErrorToast } from '../../actions/app-actions-types';
import { addGameToHistory, setMiniGamesData } from '../../actions/mini-games-action-types';
import { getRealBalanceObj, isEligibleWalletBalance, isSmartPhone } from '../../utilities/helper';
import { useLink } from 'react-router-stack';
import MilesStonesWeb from './index_web';
import { updateMilestonesData } from '../../actions/milestones-actions-types';
import { updateUserData, updateUserLevel } from '../../actions/user-actions-types';
import { allLevelsMockData } from '../../constants/milestones';
import MilesStonesMWeb from './index_mWeb';
import useTheme from '../../utilities/hooks/theme';

const MileStones = () => {
  const { gamesList: mileStoneList } = useSelector((state: any) => state.milestones);
  const userCurrentXp = useSelector((state: any) => state.user?.xpPoints || 0);
  const dispatch = useDispatch();
  const { AccountTheme: theme } = useTheme();

  const navigate = useLink();
  const [confimationModal, setConfirmationModal] = useState(false);
  const [gameDetails, setGameDetails] = useState({} as any);
  const { balanceInfo, xpPoints } = useSelector((state: any) => state.user);
  const balance: any = getRealBalanceObj(balanceInfo);

  const onPlayGameClick = (selectedGame: any) => {
    if (isEligibleWalletBalance(balance['totalBalance'], selectedGame.contest.entryFee)) {
      setGameDetails(selectedGame);
      setConfirmationModal(true);
    } else {
      dispatch(showErrorToast('Insufficient Funds'));
    }
  };
  const onPressDismiss = () => {
    setConfirmationModal(false);
  };
  const onConfirmationHandler = () => {
    setConfirmationModal(false);
    dispatch(addGameToHistory(gameDetails));
    dispatch(setMiniGamesData(gameDetails));
    ///updatingMilestonelist
    const idx = mileStoneList.findIndex((item: any) => item.gameName === gameDetails.gameName);
    const temp = [...mileStoneList];
    temp[idx] = {
      ...gameDetails,
      playedCount: gameDetails.playedCount < 5 ? gameDetails.playedCount + 1 : 5
    };

    //calcuate and setting current user level
    const currentLevelIdx = allLevelsMockData.findIndex(
      (item: any) => item.xp_required >= userCurrentXp + parseInt(gameDetails.xpAvailable)
    );
    const currentLevel = allLevelsMockData.find(
      (item: any) => item.xp_required >= userCurrentXp + parseInt(gameDetails.xpAvailable)
    );
    const currentUserLevel =
      currentLevel?.xp_required == userCurrentXp + parseInt(gameDetails.xpAvailable)
        ? currentLevelIdx
        : currentLevelIdx - 1;

    dispatch(
      updateUserData({
        // userLevel: currentUserLevel,
        xpPoints: xpPoints + parseInt(gameDetails.xpAvailable)
      })
    );
    dispatch(updateUserLevel(currentUserLevel));
    dispatch(updateMilestonesData(temp));
    if (gameDetails.gameType === 'playerVsPlayer') {
      navigate.push('/match_making');
    } else {
      navigate.push(`/games/${gameDetails.gameSlug}`);
    }
  };
  const mileStonepercentageCalculator = (currentCount: any) => {
    let percentage: any = (currentCount * 100) / 5;
    percentage = Math.round(percentage);
    return `${percentage}%`;
  };
  const gameInfoContainerStyle = {
    background: isSmartPhone
      ? theme.dailyRewardsGameInfoContainerBgMobile
      : theme.dailyRewardsGameInfoContainerBg,
    borderTop: isSmartPhone ? '' : `1px solid ${theme.dailyRewardsGameInfoContainerBorder}`,
    borderBottom: isSmartPhone ? '' : `1px solid ${theme.dailyRewardsGameInfoContainerBorder}`,
    boxShadow: isSmartPhone
      ? theme.dailyRewardsGameInfoContainerBoxShadowMobile
      : theme.dailyRewardsGameInfoContainerBoxShadow
  };
  const gamePlayContainerStyle = {
    background: theme.dailyRewardsGamePlayContainerBg,
    boxShadow: theme.dailyRewardsGamePlayContainerBoxShadow,
    borderRight: `1px solid ${theme.dailyRewardsGameInfoContainerBorder}`,
    borderTop: `1px solid ${theme.dailyRewardsGameInfoContainerBorder}`,
    borderBottom: `1px solid ${theme.dailyRewardsGameInfoContainerBorder}`
  };
  const mileStoneProgressStyle = {
    background: theme.dailyRewardsMileStoneProgressBg,
    border: 'none'
  };
  const mileStoneProgressedAreaStyle = {
    background: theme.dailyRewardsMileStoneProgressedAreaBg
  };
  return (
    <React.Fragment>
      {!isSmartPhone ? (
        <MilesStonesWeb
          mileStoneList={mileStoneList}
          confirmationModal={confimationModal}
          onPlayGameClick={onPlayGameClick}
          onPressDismiss={onPressDismiss}
          entryFee={gameDetails?.contest?.entryFee || 0}
          onConfirmationHandler={onConfirmationHandler}
          mileStonepercentageCalculator={mileStonepercentageCalculator}
          gameInfoContainerStyle={gameInfoContainerStyle}
          mileStoneProgressStyle={mileStoneProgressStyle}
          gamePlayContainerStyle={gamePlayContainerStyle}
          mileStoneProgressedAreaStyle={mileStoneProgressedAreaStyle}
        />
      ) : (
        <MilesStonesMWeb
          mileStoneList={mileStoneList}
          confirmationModal={confimationModal}
          onPlayGameClick={onPlayGameClick}
          onPressDismiss={onPressDismiss}
          entryFee={gameDetails?.contest?.entryFee || 0}
          onConfirmationHandler={onConfirmationHandler}
          mileStonepercentageCalculator={mileStonepercentageCalculator}
          gameInfoContainerStyle={gameInfoContainerStyle}
          mileStoneProgressStyle={mileStoneProgressStyle}
          mileStoneProgressedAreaStyle={mileStoneProgressedAreaStyle}
        />
      )}
    </React.Fragment>
  );
};

export default MileStones;
